module.exports = __webpack_public_path__ + "img/-e-photo_03@2x.9bf9d4a9.png";